import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../../../../../atoms/BillingAtom";
import upsellsAtom from "../../../../../atoms/UpsellsAtom";
import { TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";
import { HasFee } from "../Payment";
import { UpSaleContainer } from "./upsellStyles";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Maintitle = styled.div`
  font: normal normal bold 58px "Helvetica Neue";
  /* color: rgb(1, 113, 0); */
  text-align: center;

  padding-bottom: 15px;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 38px;
  }
`;

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  width: 100%;
  padding-left: 15%;
  padding-right: 15%;
`;

const MiddleTitle = styled.div`
  font: normal normal bold 40px "Helvetica Neue";
  color: rgb(0, 0, 0);
  /* text-align: center; */

  padding-top: 10px;
  padding-bottom: 10px;
`;
const Middlecontent = styled.div`
  font: normal normal bold 28px "Helvetica Neue";
  width: 100%;
  text-align: left;
  padding-left: 3rem;
  > p {
    font: normal normal bold 18px "Helvetica Neue";

    @media (max-width: ${TABLET_WIDTH}) {
      font-size: 21px;
    }
  }
`;

const ActionDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 30px 10%;
  width: 100%;
  /* margin-top: 10px; */
  /* margin-bottom: 20px; */
`;

const ActionTitle = styled.div`
  font: normal normal bold 23px "Helvetica Neue";
  padding-bottom: 15px;
`;
const ActionContent = styled.div`
  font-size: 16px;
`;

interface IThankYouPage {
  closeModal: () => void;
  isModal?: boolean;
}

export default function ThankYouPage(props: IThankYouPage): JSX.Element {
  const { closeModal, isModal } = props;

  const [total, setTotal] = useState<number>();

  const hasFee = useRecoilValue(HasFee);

  const upsells = useRecoilValue(upsellsAtom);
  const billing = useRecoilValue(billingAtom);
  // const upsells = [
  //   {
  //     description: "SocialLair Subscription",
  //     price: 3500,
  //   },
  //   {
  //     description: "SocialLair Extra Lairs x 5",
  //     price: 2500,
  //   },
  //   {
  //     description: "Subscription Biz",
  //     price: 9100,
  //   },
  //   {
  //     description: "360 Content Creation",
  //     price: 40100,
  //   },
  // ];

  useEffect(() => {
    if (upsells) {
      let partialTotal = 0;
      upsells.map((item) => {
        partialTotal += item.price;
      });

      if (billing.admins) {
        partialTotal +=
          (billing.adminPrice || 10) * (billing.admins || 0) * 100;
      }
      if (billing.externalUsers) {
        partialTotal +=
          (billing.externalUserPrice || 10) *
          (billing.externalUsers || 0) *
          100;
      }

      setTotal(partialTotal);
    }
  }, [upsells, billing]);

  return (
    <UpSaleContainer isModal={isModal}>
      <Header>
        <Maintitle>Thank you!</Maintitle>
      </Header>
      <Middle>
        <MiddleTitle>Products:</MiddleTitle>
        <Middlecontent>
          {upsells[0] && (
            <p
              style={{
                display: "flex",
                fontWeight: "normal",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "14em" }}>{upsells[0].description}</div>
              <div style={{ width: "4em", textAlign: "right" }}>
                ${(upsells[0].price / 100.0).toFixed(2)}
              </div>
            </p>
          )}
          {hasFee && (
            <p
              style={{
                display: "flex",
                fontWeight: "normal",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "14em" }}>Set Up Fee</div>
              <div style={{ width: "4em", textAlign: "right" }}>
                ${billing.setupFeePrice.toFixed(2)}
              </div>
            </p>
          )}
          {billing.admins !== 0 && (
            <p
              style={{
                display: "flex",
                fontWeight: "normal",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "14em" }}>
                Internal Users x {billing.admins}
              </div>
              <div style={{ width: "4em", textAlign: "right" }}>
                $
                {((billing.adminPrice || 10) * (billing.admins || 0)).toFixed(
                  2
                )}
              </div>
            </p>
          )}
          {billing.externalUsers !== 0 && (
            <p
              style={{
                display: "flex",
                fontWeight: "normal",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "14em" }}>
                External Users x {billing.externalUsers}
              </div>
              <div style={{ width: "4em", textAlign: "right" }}>
                $
                {(
                  (billing.externalUserPrice || 10) *
                  (billing.externalUsers || 0)
                ).toFixed(2)}
              </div>
            </p>
          )}
          {upsells?.map(
            (item, index) =>
              index !== 0 && (
                <p
                  style={{
                    display: "flex",
                    fontWeight: "normal",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "14em" }}>{item.description}</div>
                  <div style={{ width: "4em", textAlign: "right" }}>
                    ${(item.price / 100.0).toFixed(2)}
                  </div>
                </p>
              )
          )}
          {total && (
            <>
              <hr />
              <p
                style={{
                  display: "flex",
                  fontWeight: "bolder",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "14em" }}>Total</div>
                <div style={{ width: "4em", textAlign: "right" }}>
                  ${(total / 100.0 + billing.setupFeePrice).toFixed(2)}
                </div>
              </p>
            </>
          )}
        </Middlecontent>
      </Middle>
      <ActionDiv>
        <ActionTitle>Thank you for purchasing BerserkerMail</ActionTitle>
        <StyledButton
          style={{ height: 60, width: "80%", marginTop: "15px" }}
          onClick={closeModal}
        >
          Close
        </StyledButton>
      </ActionDiv>
    </UpSaleContainer>
  );
}
